import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-header-title" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "delete-confirm-body" }
const _hoisted_4 = {
  class: "delete-confirm-warning",
  role: "alert"
}

interface Props {
  modelValue: boolean;
  title: string;
  targetName: string;
  message: string;
  warning?: string;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteConfirmDialog',
  props: {
    modelValue: { type: Boolean },
    title: {},
    targetName: {},
    message: {},
    warning: { default: '이 작업은 되돌릴 수 없습니다.' },
    loading: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "440px",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "delete-confirm-dialog" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "dialog-header" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  class: "mr-2",
                  color: "error"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("mdi-alert-circle", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(__props.title), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "dialog-close",
                "aria-label": "닫기",
                disabled: __props.loading,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ], 8, _hoisted_2)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("strong", null, _toDisplayString(__props.targetName), 1),
                _createTextVNode(" " + _toDisplayString(__props.message), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: "#b71c1c"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("mdi-alert-octagon", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(__props.warning), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "dialog-actions" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                class: "btn-cancel",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false))),
                disabled: __props.loading
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("취소", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                variant: "flat",
                class: "btn-delete",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirm'))),
                loading: __props.loading
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("삭제", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})